<div class="modal-body content width-500 ">
    <div class="layout-auto-1-auto">
    <span class="modal-header">
      {{'Neuer PDF-Name'}}
    </span>
    <div class="layout-auto-1">
      <exg-checkbox *ngIf="excSecurity.isFeatured('CASEEDIT')"
                    [(ngModel)]="uiSaveInCase"
                    caption="Zum Auftrag speichern"
                    disabled="{{uiSaveInCaseDisabled}}">
      </exg-checkbox>
      <exg-select #task
                  *ngIf="!uiSaveInCase && !uiSaveInCaseDisabled"
                  name="TaskSelect"
                  caption="{{getGlobal('Task')}}"
                  [(ngModel)]="uiSelectTaskIndex"
                  (ngModelChange)="setSelectedTask($event); task.closed=true"
                  [list]="uiTaskList"
                  listdisplay="vorgNr">
      </exg-select>
      <exg-select #t name="DokTypeSelect"
                  caption="{{enumSvc.getFieldCaption('Dokument','dok_enmIdent_DokTyp')}}"
                  [(ngModel)]="uiSelectDocumentTypeIndex"
                  (ngModelChange)="setDocumentType($event); t.closed=true"
                  [list]="enumSvc.getEnumerationList('DokTyp')"
                  listdisplay="enmText">
      </exg-select>
    </div>
    <div>
      <exg-input [(ngModel)]="filename"
                 [caption]="'Dateiname (inkl. ' + nummerTyp + ')'"
                 type="text">
      </exg-input>
		</div>
		<div class="spawn-modal-actions typo-small" style="margin-top: 2rem">
			<button (click)="cancel()" class="md-btn">
				{{getGlobal('Cancel')}}
			</button>
			<button (click)="save()"
			        [class.disabled]="filename.length === 0 || !isFilenameModified()"
			        class="md-btn">
				{{getGlobal('Create')}}
			</button>
		</div>
	</div>
</div>
